<template>
    <div v-if="freeTextEnabled">
        <p class="body-semibold">{{ t("profile.collaboration.sources.freeText.title") }}</p>
        <p class="body-small text-ink-muted mt-1">{{ t("profile.collaboration.sources.freeText.description") }}</p>
        <VoiceTextarea
            v-model:input="freeText"
            class="mt-2"
            :rows="5"
            :maxlength="MAX_FREE_TEXT_LENGTH"
            :placeholder="t('profile.collaboration.sources.freeText.placeholder')"
            :textarea-aria-label="t('profile.collaboration.sources.freeText.inputLabel')"
            textarea-class="body-small" />
        <output class="block text-right details text-ink-muted" :aria-label="t('profile.collaboration.sources.freeText.characterCount')">
            <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -- numeric counter, no translatable text -->
            {{ formatNumber(freeText.length) }}/{{ formatNumber(MAX_FREE_TEXT_LENGTH) }}
        </output>
    </div>
</template>

<script setup lang="ts">
import VoiceTextarea from "~vue/components/form/VoiceTextarea.vue";
import { formatNumber } from "~vue/utils/formatNumber";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const MAX_FREE_TEXT_LENGTH = 50000;

type FreeTextUploadProps = {
    freeTextEnabled: boolean;
};

defineProps<FreeTextUploadProps>();

const freeText = defineModel<string>("freeText", { required: true });
</script>

<style scoped></style>
